import { styles } from "../styles";

export default function LoginPage({ auth }) {
  const {
    email,
    setEmail,
    password,
    setPassword,
    saveUsername,
    setSaveUsername,
    keepLoggedIn,
    setKeepLoggedIn,
    authError,
    handleLogin,
    handleRegister,
  } = auth;

  return (
    <div
      style={{
        minHeight: "calc(100vh - 100px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "16px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "380px",
          background: "white",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          padding: "24px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: 16, textAlign: "center" }}>
          Login
        </h2>

        {authError && (
          <div style={{ color: "red", marginBottom: 12 }}>{authError}</div>
        )}

        <input
          style={{ ...styles.input, maxWidth: "100%" }}
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          style={{ ...styles.input, maxWidth: "100%" }}
          placeholder="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <label style={{ display: "block", marginTop: 12, marginBottom: 8 }}>
          <input
            type="checkbox"
            checked={saveUsername}
            onChange={(e) => setSaveUsername(e.target.checked)}
          />
          {" "}Save username
        </label>

        <label style={{ display: "block", marginBottom: 16 }}>
          <input
            type="checkbox"
            checked={keepLoggedIn}
            onChange={(e) => setKeepLoggedIn(e.target.checked)}
          />
          {" "}Keep me logged in
        </label>

        <button
          onClick={handleLogin}
          style={{ ...styles.primaryButton, width: "100%", margin: "0 0 8px" }}
        >
          Login
        </button>
        {/* TechnicianLogs is currently invite-only — there's no self-serve
            account creation. The button mails sales/info so we can talk
            to the prospect first, then onboard them via createUserForOrg. */}
        <a
          href={
            "mailto:info@technicianlogs.com" +
            "?subject=Interested%20in%20signing%20up%20for%20TechnicianLogs" +
            "&body=Company%3A%20%0AYour%20role%3A%20%0AContractor%20or%20facility%3F%3A%20%0AService%20area%20%2F%20vertical%3A%20%0ATeam%20size%3A%20%0AAnything%20we%20should%20know%3A%20"
          }
          style={{
            ...styles.button,
            width: "100%",
            margin: 0,
            display: "inline-block",
            textAlign: "center",
            textDecoration: "none",
            boxSizing: "border-box",
          }}
        >
          Sign Up
        </a>
      </div>
    </div>
  );
}
